const FormPage = ({ children }) => {
    return <div>{children}</div>;
};

export default FormPage;
